import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

// Actions:
import {
  submit3dsDataAction,
  submit3dsDataFailAction,
} from '../../store/payment/reducer';

// Selectors:
import {
  getShow3dsHiddenPopup,
  getPayment3dsHiddenData,
} from '../../store/payment/selectors';

const iframeName = 'paymentIframe3dsMethod';

const mapStateToProps = (state) => ({
  isOpened: getShow3dsHiddenPopup(state),
  data: getPayment3dsHiddenData(state),
});
const mapDispatchToProps = (dispatch) => ({
  submit: () => dispatch(submit3dsDataAction()),
  failed: () => dispatch(submit3dsDataFailAction()),
});

export const PaymentHidden3dsPopup = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props) => {
  const { data, submit, failed, isOpened } = props;
  if (!isOpened) return null;
  const formRef = useRef();

  const { url, data: threeDSMethodData } = data;

  let timeout;
  useEffect(() => {
    formRef.current.submit();
    timeout = setTimeout(failed, 10000);
  }, []);

  const width = 500;
  const height = 550;

  return (
    <>
      <form
        style={{ position: 'absolute', left: -4000 }}
        target={iframeName}
        ref={formRef}
        method="post"
        action={url}
      >
        <input
          type="hidden"
          name="threeDSMethodData"
          value={threeDSMethodData}
        />
      </form>
      <iframe
        name={iframeName}
        id={iframeName}
        title={iframeName}
        width={width}
        height={height}
        onLoad={() => {
          try {
            if (timeout) {
              clearTimeout(timeout);
            }
            submit();
          } catch (error) {
            console.error(error);
          }
        }}
      />
    </>
  );
});
